import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../theme";
import backgroundImage from "../../assets/connect.png";

const Subtitle = styled(motion.p)`
  color: #64748b;
  margin-bottom: 2rem;
  font-family: "Inter", sans-serif;
  @media (max-width: 480px) {
    font-size: 1rem;
    width: 95%;
  }
`;

const Form = styled(motion.form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled(motion.input)`
  width: 95%;
  padding: 8px 10px 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  color: ${theme.colors.text.primary};
  &::placeholder {
    font-size: 12px;
    color: #9ca3af; /* Optional: Placeholder color */
    font-family: "Inter", sans-serif;
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 85%;
  }
`;

const TextArea = styled(motion.textarea)`
  width: 95%;
  padding: 0.75rem;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;
  min-height: 30px;
  resize: vertical;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  color: ${theme.colors.text.primary};
  &::placeholder {
    font-size: 12px;
    color: #9ca3af; /* Optional: Placeholder color */
    font-family: "Inter", sans-serif;
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 85%;
  }
`;

const RecaptchaWrapper = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 768px) {
    transform: scale(0.85);
    transform-origin: center;
  }
`;

const SubmitButton = styled(motion.button)`
  background: ${theme.colors.gradient.themeGradient};
  color: white;
  padding: 8px;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  height: 40px;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  width: 100%;
  text-align: center;

  &:hover {
    background-color: ${theme.colors.buttonhover};
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 90%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
`;

const Label = styled(motion.p)`
  color: ${theme.colors.primary};
  margin-top: -0.5rem;
  font-size: 16px;
  font-family: "Inter", sans-serif;
`;

const Title = styled(motion.h2)`
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1;
  font-family: "Inter", sans-serif;

  span {
    color: ${theme.colors.primary};
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 480px) {
    font-size: 1.5rem;
    width: 95%;
  }
`;

const Container = styled(motion.div)`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  border-radius: 50px;
  border: 1px solid #ccc;
  overflow: hidden;
  background-color: ${theme.colors.white};

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ImageContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FormSection = styled(motion.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1rem;
  }
  @media (max-width: 480px) {
    font-size: 1.5rem;
    padding: 1rem;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const MainContainer = styled(motion.div)`
  padding: 50px;
  background-color: ${theme.colors.primary};
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

// Styled Components
const PageWrapper = styled.div`
  min-height: 100vh;
  // max-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url(${backgroundImage}) no-repeat center center fixed;
  background-size: cover;
`;
const TopBar = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 30px 0px 30px;
  color: white;
  font-weight: bold;

  img {
    width: clamp(120px, 10vw, 160px);
    height: auto;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 0px 20px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Card = styled.div`
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: clamp(1rem, 5vw, 2rem);
  width: 100%;
  max-width: 550px;
  box-sizing: border-box;
  background: ${theme.colors.background.paper};
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 20px;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const HeaderContainer = styled.div`
  margin-bottom: 1rem;
`;

const Heading = styled.h1`
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: ${theme.colors.text.primary};
  margin: 8px 0px 8px 0px;
  font-family: "Inter", sans-serif;
`;

const SubText = styled.p`
  color: ${theme.colors.text.tertiary};
  font-size: clamp(0.875rem, 2vw, 1rem);
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  color: #6b7280;
  font-size: 0.875rem;
  span {
    font-family: "Inter", sans-serif;
  }

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e5e7eb;
  }

  &::before {
    margin-right: 0.75em;
  }

  &::after {
    margin-left: 0.75em;
  }
`;

const AlternativeAction = styled.div`
  text-align: center;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #6b7280;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  // margin-bottom: 20px;
  span {
    font-family: "Inter", sans-serif;
  }
`;

const AlternativeButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
  font-family: "Inter", sans-serif;

  &:hover {
    color: ${theme.colors.primary};
    text-decoration: underline;
  }
`;

const SC = {
  Container,
  ImageContainer,
  Image,
  FormSection,
  InputWrapper,
  Form,
  Input,
  TextArea,
  RecaptchaWrapper,
  SubmitButton,
  Label,
  Title,
  Subtitle,
  MainContainer,
  PageWrapper,
  TopBar,
  MainContent,
  ImageWrapper,
  FormWrapper,
  Card,
  HeaderContainer,
  Heading,
  SubText,
  Divider,
  AlternativeAction,
  AlternativeButton,
};

export default SC;
